import {createStore} from "redux";
import IndexReducer from "../Reducers/IndexReducer";


const ReduxStore = createStore(IndexReducer);

export default ReduxStore;
